export default __webpack_public_path__ + "static/media/2099-big.c056c7b3.svg";